module.exports = __webpack_public_path__ + "img/pumpkin-chocolate-chip-brownies.b18633d2.jpg";